import { useBackend } from "../../services";

export const useGetAlbumFormatProducts = () => {
  const { get } = useBackend();
  const getAlbumFormatProducts = () => get("products/albumFormats");
  return { getAlbumFormatProducts };
};
